
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import {
  default as CrudModel,
  ProPostCategory,
} from '../../models/proPostCategories.model';
import Pagination from '../../components/ui/Pagination.vue';
import swal from '../../helper/swal.helper';

export default defineComponent({
  name: 'ProPostCategories',
  props: {},
  components: {
    Pagination,
  },
  setup: () => {
    const router = useRouter();
    let categories = ref<ProPostCategory[]>([]);
    let loading = ref(false);
    let orderOptions = ref([['order_number', 'asc']]);
    let filterConditions = ref<Array<any>>([]);
    function updateData(items: ProPostCategory[]) {
      loading.value = false;
      categories.value = items;
    }
    function isLoading(status: boolean) {
      loading.value = status;
    }
    async function editRecord(id: any) {
      router.push('/pro-post-categories/edit/' + id);
    }
    async function deleteRecord(id: any) {
      swal.simpleDeleteConfirm(async function() {
        loading.value = true;
        await CrudModel.delete(id);
        categories.value = await CrudModel.getAll();
        loading.value = false;
      });
    }
    return {
      categories,
      loading,
      orderOptions,
      filterConditions,
      updateData,
      isLoading,
      CrudModel,
      deleteRecord,
      editRecord,
    };
  },
});
